<template>
  <div class="primary">
    <div v-if="cropList.length" :class="`images images-${myCropList.length}`">
      <van-image
        v-for="(item,key) in myCropList"
        :key="key"
        round
        fit="cover"
        class="image"
        :src="item.cropPic"
      />
    </div>
    <div v-else class="empty">
      闲置中
    </div>
  </div>
</template>

<script>
export default {
  name: 'CropCoverImage',
  props: {
    cropList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  computed: {
    myCropList() {
      if (this.cropList && this.cropList.length) {
        const cropBreedNames = []
        // filter 对同一地块相同作物展示去重
        const uniqCropList = this.cropList.filter(item => {
          if (cropBreedNames.includes(item.cropBreed)) {
            return false
          } else {
            cropBreedNames.push(item.cropBreed)
            return true
          }
        })
        if (this.cropList.length > 4) {
          return uniqCropList.slice(0, 4) // 最多展示4个作物
        } else {
          return uniqCropList
        }
      } else {
        return this.cropList
      }
    }

  }
}
</script>

<style lang='less' scoped>
.primary {
  text-align: center;
  background: #fff;
  .empty {
    font-size: 16px;
    letter-spacing: 0.1em;
    font-weight: bold;
    color: #cccccc;
    padding-top: 30%;
  }
  .images {
    width: 100%;
    height: 100%;
    position: relative;
    &.images-1 {
      display: flex;
      .image {
        position: relative;
        width: 100%;
        height: 100%;
        margin: auto;
      }
    }

    &.images-2,
    &.images-3,
    &.images-4 {
      .image {
        position: absolute;
        width: 60%;
        height: 60%;
      }
    }

    &.images-2 {
      .image {
        &:nth-child(1) {
          left: 5%;
          top: 5%;
          z-index: 1;
        }
        &:nth-child(2) {
          right: 5%;
          bottom: 5%;
          z-index: 2;
        }
      }
    }

    &.images-3 {
      .image {
        width: 55%;
        height: 55%;
        &:nth-child(1) {
          left: 0;
          top: 0%;
          z-index: 1;
        }
        &:nth-child(2) {
          right: 0;
          top: 12%;
          z-index: 3;
        }
        &:nth-child(3) {
          left: 12%;
          bottom: 0;
          z-index: 2;
        }
      }
    }

    &.images-4 {
      .image {
        width: 54%;
        height: 54%;
        &:nth-child(1) {
          left: 0;
          top: 0;
          z-index: 1;
        }
        &:nth-child(2) {
          left: 2%;
          bottom: 8%;
          z-index: 2;
        }
        &:nth-child(3) {
          top: 8%;
          right: 2%;
          z-index: 3;
        }
        &:nth-child(4) {
          right: 0;
          bottom: 0;
          z-index: 4;
        }
      }
    }
  }
}
</style>
